import { MouseEvent, useRef } from 'react';

const DEFAULT_LONG_PRESS_TIMEOUT = 1000;

interface UseLongPressOptions {
  timeout?: number;
}

export function useLongPress(onLongPress: () => void, options: UseLongPressOptions = {}) {
  const { timeout = DEFAULT_LONG_PRESS_TIMEOUT } = options;

  const timerRef = useRef<Nullable<SetTimeout>>(null);
  const firedRef = useRef(false);

  function clearTimer() {
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }

  function onMouseDown() {
    firedRef.current = false;
    clearTimer();
    timerRef.current = setTimeout(() => {
      firedRef.current = true;
      onLongPress();
    }, timeout);
  }

  function onMouseUp() {
    clearTimer();
  }

  function onMouseLeave() {
    clearTimer();
    firedRef.current = false;
  }

  function onClick(e: MouseEvent) {
    if (firedRef.current) {
      e.preventDefault();
      firedRef.current = false;
    }
  }

  return { onMouseDown, onMouseUp, onMouseLeave, onClick };
}
